import { render, staticRenderFns } from "./shared-health-records.vue?vue&type=template&id=39be2f1a&scoped=true&"
import script from "./shared-health-records.vue?vue&type=script&lang=js&"
export * from "./shared-health-records.vue?vue&type=script&lang=js&"
import style0 from "./shared-health-records.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./shared-health-records.vue?vue&type=style&index=1&id=39be2f1a&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "39be2f1a",
  null
  
)

export default component.exports